import React from 'react';
import { Field, reduxForm } from 'redux-form/immutable';
import PropTypes from 'prop-types';
import NavbarModulo from '../../components/NavbarModulo';
import TablaDetalle from './NotaDebitoDetalle';
import TablaDetalleVer from './NotaDebitoVer';
import TablaDetalleMod from './NotaDebitoMod';
import classNames from 'classnames';

import styled from 'styled-components';

import {
    renderField,
    AsyncSelectField,
    renderDayPickerB,
    renderCurrencyFloat,
    AsyncSelectFieldIn,
} from "../../Utils/renderField/renderField";

function NotaDebitoForm(props) {
    const {
        crear,
        detalleND,
        modulo,
        listarDistribuidor,
        periodoD,
        registroNotaDebito,
        datos,
        agregarLinea,
        detalleDocN,
        eliminarDocumento,
        modificarNotaDebito,
        agregarNuevaLinea,
        eliminarLineaNota,
        cuentaContable,
        buscarCuenta,
        gastos,
        distribuidorCC,
        list_distribuidor_cc,
        centro_costo,
        nombre_centro_costo
    } = props;

    const estilo = {
        overflow: "auto",
        height: "300px",

    };
    const editar = window.location.href.includes('editar');
    let titulo = editar ? 'Modificar nota débito' : 'Nueva nota débito';
    let disabled = false;
    if (crear === false && editar === false) {
        disabled = true;
        titulo = 'Ver nota débito'
    }
    
    let ruta = window.location.href;
    let id_emp = ruta.split('/');

    const handleOnChangeGasto = value => {
        buscarCuenta(value.value);
    };

    const handleOnChangeCC = value => {
        distribuidorCC(value.value);
    };

    return (
        <div>
            <NavbarModulo
                periodoD = {periodoD}
                modulo = {modulo}
                titulo = {titulo}
            />
            <div className="mb-4 card card-small text-white bg-dark mb-3">
                <div className="p-0 pt-3 d-flex flex-column flex-md-row">
                    <div className="d-flex flex-column flex-1 mx-4">
                        {(crear === false && editar === false) &&
                            <div className='row mb-2'>
                                <div className='col-8'>
                                    <Field
                                        name="nombre_distribuidor"
                                        placeholder="Distribuidor"
                                        component={renderField}
                                        className="form-control"
                                        msj="Distribuidor"
                                        disabled={disabled}
                                    />
                                </div>
                                <div className='col-4'>
                                    <Field
                                        name="nombre_cc"
                                        placeholder="Centro costo"
                                        component={renderField}
                                        className="form-control"
                                        msj="Centro costo"
                                        disabled={disabled}
                                    />
                                </div>
                            </div>
                        }
                        {(editar === true) &&
                            <div>
                                <div className='row mb-2'>
                                    <div className='col-8'>
                                        <Field
                                            name="nombre_distribuidor"
                                            placeholder="Distribuidor"
                                            component={renderField}
                                            className="form-control"
                                            msj="Distribuidor"
                                            disabled={disabled}
                                        />
                                    </div>
                                    <div className='col-4'>
                                        <Field
                                            name="nombre_cc"
                                            placeholder="Centro costo"
                                            component={renderField}
                                            className="form-control"
                                            msj="Centro costo"
                                            disabled={disabled}
                                        />
                                    </div>
                                </div>
                                <div className='row'>
                                    <div className='col-8'>
                                        <Field
                                            name="distribuidor_mod"
                                            placeholder="Distribuidor..."
                                            className="form-control-find"
                                            component={AsyncSelectField}
                                            loadOptions={listarDistribuidor}
                                            onChange={handleOnChangeCC}
                                            msj="Distribuidor"
                                        />
                                    </div>
                                    <div className='col-4'>
                                        <div className="form-floating">
                                            <input
                                                className = {classNames('form-control')}
                                                type="text"
                                                value = {nombre_centro_costo}
                                                disabled = {true}
                                            />
                                            <label className='form-label'>Centro costo</label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        }
                        {(crear === true) &&
                            <div className='row'>
                                <div className='col-8'>
                                    <Field
                                        name="distribuidor"
                                        placeholder="Distribuidor..."
                                        className="form-control-find"
                                        component={AsyncSelectField}
                                        loadOptions={listarDistribuidor}
                                        onChange={handleOnChangeCC}
                                        msj="Distribuidor"
                                    />
                                </div>
                                <div className='col-4'>
                                    <div className="form-floating">
                                        <input
                                            className = {classNames('form-control')}
                                            type="text"
                                            value = {nombre_centro_costo}
                                            disabled = {true}
                                        />
                                        <label className='form-label'>Centro costo</label>
                                    </div>
                                </div>
                            </div>
                        }
                        <div className='row mb-2'>
                            <div className='col-3'>
                                <Field
                                    name="fecha_registro"
                                    component={renderDayPickerB}
                                    msj="Fecha"
                                    disabled={disabled}
                                />
                            </div>
                            <div className='col-3'>
                                <Field
                                    name='numero'
                                    component={renderField}
                                    className="form-control"
                                    placeholder="Numero"
                                    disabled={disabled}
                                    msj="Numero"
                                />
                            </div>
                            {(crear === false && editar === false) &&
                                <div className='col-2'>
                                    <Field
                                        name="monto"
                                        placeholder="Total"
                                        className="form-control"
                                        component={renderCurrencyFloat}
                                        disabled={true}
                                        msj="Total"
                                    />
                                </div>
                            }
                        </div>
                        <div className='mb-2'>
                            <Field
                                name="descripcion"
                                placeholder="Referencia"
                                component={renderField}
                                className="form-control"
                                msj="Referencia"
                                disabled={disabled}
                            />
                        </div>
                        {(crear === true || editar === true) &&
                            <div>
                                <h5 className="p-2 bg-secondary title mt-1">Detalle nota débito</h5>
                                    <div className='row mb-2'>
                                        <div className='col-10'>
                                            <Field
                                                name="descripcion_linea"
                                                placeholder="Descripcion"
                                                component={renderField}
                                                className="form-control"
                                                msj="Descripción"
                                            />
                                        </div>
                                        <div className='col-2'>
                                            <Field
                                                name="total_linea"
                                                placeholder="Total"
                                                className="form-control"
                                                component={renderCurrencyFloat}
                                                msj="Total"
                                            />
                                        </div>
                                    </div>
                                    <div className='row mb-2'>
                                        <div className='col-6'>
                                            <Field
                                                name="tipo_gasto"
                                                placeholder="Tipo de gastos..."
                                                className="form-control-find"
                                                loadOptions={gastos}
                                                onChange={handleOnChangeGasto}
                                                component={AsyncSelectFieldIn}
                                                msj="Tipo de gasto"
                                            />
                                        </div>
                                        <div className='col-6'>
                                            <Field
                                                name="cuenta"
                                                placeholder="Cuenta contable..."
                                                className="form-control-find"
                                                component={AsyncSelectFieldIn}
                                                loadOptions={cuentaContable}
                                                msj="Cuenta contable"
                                            />
                                        </div>
                                    </div>
                                    <div className='row mb-2'>
                                        <div className='col-6'>
                                            <Field
                                                name="centro_costo"
                                                placeholder="Centro costo..."
                                                className="form-control-find"
                                                loadOptions={list_distribuidor_cc}
                                                component={AsyncSelectField}
                                                msj="Centro costo"
                                            />
                                        </div>
                                    </div>
                            </div>
                        }
                        {(crear === true && editar === false) &&
                            <Contenido>
                                <button
                                    className='btn mr-2 mb-3 btn-primary'
                                    onClick={() => agregarLinea(periodoD, datos)}
                                >
                                    Agregar linea
                                </button>
                            </Contenido>
                        }
                        {(crear === false && editar === true) &&
                            <Contenido>
                                <button
                                    className='btn mr-2 mb-3 btn-primary'
                                    onClick={() => agregarNuevaLinea(periodoD)}
                                >
                                    Agregar linea
                                </button>
                            </Contenido>
                        }
                        <br/>
                        {(crear === true) &&
                            <div>
                                <h5 className="p-2 bg-secondary title mt-1">Detalle nota débito</h5>
                                <div style={estilo}>
                                    <TablaDetalle
                                        detalle={detalleDocN}
                                        eliminarDocumento={eliminarDocumento}
                                    />
                                </div>
                            </div>
                        }
                        {(editar === true) &&
                            <div>
                                <h5 className="p-2 bg-secondary title mt-1">Detalle nota débito</h5>
                                <div style={estilo}>
                                    <TablaDetalleMod
                                        detalle={detalleND}
                                        eliminarDocumento={eliminarLineaNota}
                                    />
                                </div>
                            </div>
                        }
                        {(crear === false && editar === false) &&
                            <div style={estilo}>
                                <h5 className="p-2 bg-secondary title mt-1">Detalle nota débito</h5>
                                <TablaDetalleVer
                                    detalle={detalleND}
                                />
                            </div>
                        }
                        <br />
                        <div className='d-flex flex-row mt-3'>
                            {(crear === true && editar === false) &&
                                <button
                                className='btn mr-2 mb-3 btn-primary'
                                onClick={() => registroNotaDebito(periodoD)}
                                >
                                    Guardar
                                </button>
                            }
                            {(editar === true && crear === false) &&
                                <button
                                className='btn mr-2 mb-3 btn-primary'
                                onClick={() => modificarNotaDebito(periodoD)}
                                >
                                    Modificar
                                </button>
                            }
                            <a
                                href = {`/#/visitador_medico/${id_emp[5]}/nota_debito/${id_emp[7]}`}
                                className='btn btn-secondary mb-3'
                            >
                                Regresar
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

NotaDebitoForm.propTypes = {
    crear: PropTypes.bool,
    lectura: PropTypes.object,
    editar: PropTypes.bool,
    bloqueo: PropTypes.bool,
    modulo: PropTypes.object,
    periodoD: PropTypes.object,
    datos: PropTypes.object,
};

const Contenido = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;

`;

export default reduxForm({
    form: 'FormNotaDebitoVM',
})(NotaDebitoForm);
